import { UserIdViewModel } from "../features/user-id/user-id-viewmodel";
export class ViewModelContainer {
    static instance;
    registry = new WeakMap();
    factories = new Map();
    constructor() {
    }
    ;
    static getInstance() {
        if (!this.instance) {
            this.instance = new ViewModelContainer();
        }
        return this.instance;
    }
    static resetContainerWithUserId(userId) {
        if (process.env.NODE_ENV === "development") {
            console.log(`Clearing container and setting new User ID: ${userId}`);
        }
        const container = this.getInstance();
        container.resetContainer();
        container.getViewModel(UserIdViewModel).setUserId(userId);
        return this.getInstance();
    }
    // Register a ViewModel with its factory
    registerViewModel(viewModelClass, factory) {
        if (this.factories.has(viewModelClass)) {
            throw new Error(`ViewModel for ${viewModelClass} is already registered`);
        }
        this.factories.set(viewModelClass, factory);
    }
    // Get or create ViewModel by class
    getViewModel(viewModelClass, ...args) {
        if (this.registry.has(viewModelClass)) {
            return this.registry.get(viewModelClass);
        }
        // miss
        const factory = this.factories.get(viewModelClass);
        if (!factory) {
            throw new Error(`No factory registered for ViewModel: ${viewModelClass.name}`);
        }
        const instance = factory(...args);
        this.registry.set(viewModelClass, instance);
        return instance;
    }
    removeViewModel(viewModelClass) {
        if (this.registry.delete(viewModelClass)) {
            if (process.env.NODE_ENV === "development") {
                console.log(`ViewModel for ${viewModelClass.name.slice(0, 25)} removed`);
            }
        }
        else {
            if (process.env.NODE_ENV === "development") {
                console.log(`No ViewModel found for ${viewModelClass.name.slice(0, 25)}`);
            }
        }
    }
    resetContainer() {
        this.registry = new WeakMap();
        if (process.env.NODE_ENV === "development") {
            console.log("Registry cleared");
        }
    }
}
